/**
 * Mainbeauty — nút chia sẻ ở trang chi tiết bài viết ([data-pi-share]).
 */

const NETWORKS = {
  facebook: (url) =>
    "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(url),
  zalo: (url) => "https://zalo.me/share/link?u=" + encodeURIComponent(url),
  linkedin: (url) =>
    "https://www.linkedin.com/sharing/share-offsite/?url=" +
    encodeURIComponent(url),
};

function flash(btn, label) {
  const original = btn.textContent;
  btn.textContent = label;
  btn.classList.add("is-done");
  setTimeout(() => {
    btn.textContent = original;
    btn.classList.remove("is-done");
  }, 1600);
}

function copyLink(btn, url) {
  const done = () => flash(btn, "✓");

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(url).then(done, () => fallback(url, done));
    return;
  }
  fallback(url, done);
}

// http:// hoặc trình duyệt cũ — clipboard API không có ở đó.
function fallback(url, done) {
  const input = document.createElement("textarea");
  input.value = url;
  input.setAttribute("readonly", "");
  input.className = "visually-hidden";
  document.body.appendChild(input);
  input.select();
  try {
    document.execCommand("copy");
    done();
  } catch (e) {
    window.prompt("Sao chép đường dẫn:", url);
  }
  input.remove();
}

document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-pi-share-to]");
  if (!btn) return;

  const box = btn.closest("[data-pi-share]");
  if (!box) return;

  const url = box.getAttribute("data-pi-share-url") || window.location.href;
  const title = box.getAttribute("data-pi-share-title") || document.title;
  const to = btn.getAttribute("data-pi-share-to");

  if (to === "copy") {
    copyLink(btn, url);
    return;
  }

  // Sheet native trên mobile hơn hẳn popup window dễ bị chặn.
  if (navigator.share && window.matchMedia("(max-width: 767px)").matches) {
    navigator.share({ title: title, url: url }).catch(() => {});
    return;
  }

  const build = NETWORKS[to];
  if (build) {
    window.open(build(url), "_blank", "noopener,width=640,height=560");
  }
});
